import { render } from "./custom-link.vue?vue&type=template&id=ad5121a6&lang=pug"
import script from "./custom-link.vue?vue&type=script&lang=js"
export * from "./custom-link.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__